export const mainColor = '#54AB34'
export const kyoboThemeBlue = '#003975'


export default {
  mainColor,
  kyoboThemeBlue,
}
